export default {
      id: "oc-menu-star-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-menu-star",
      toString: function () {
        return this.url;
      }
    }